import { createTheme } from "@mui/material/styles";
import { getPaletteLight } from "./palette/light";
import { getPaletteDark } from "./palette/dark";
import { getTypography } from "./typography/typography";
import { getComponentOverrides } from "./components";

export const generateRewampTheme = (fontSize, mode) => {
  const isDark = mode === "dark";
  const lightPalette = getPaletteLight();
  const palette = isDark ? getPaletteDark(lightPalette) : lightPalette;
  
  const baseTheme = createTheme({
    palette: {
      mode,
      ...palette,
    },
    // Custom property to expose the exact style guide spacing tokens
    spacingTokens: palette.spacingTokens,
    controls: palette.controls,
    typography: getTypography(palette),
  });

  return createTheme(baseTheme, {
    components: getComponentOverrides(baseTheme)
  });
};

export default generateRewampTheme;
// Static palette objects for the few consumers that read tokens at module scope
// (AccessibilityContext CSS-variable bridge, RewampFeedbackBanner, RewampScrollRow).
export const rewampPalette = getPaletteLight();
export const rewampPaletteDark = getPaletteDark(rewampPalette);
